module.exports = __webpack_public_path__ + "static/media/selo-bronze-de-inovacao.43939c78.png";